import React from 'react';

import { t, translate } from 'react-switch-lang';
import { moveFocusTo } from '../utils/Accessibility';
import styles from '../styles/SkipToContent.module.scss';
import { formatAsTestId } from '../utils/Helpers';

function SkipToContent() {
  return (
    <div id={styles.SkipTo}>
      <SkipToButton skipTo="main" scrollTop textKey="SkipToContent_Button" />
      <SkipToButton skipTo="footer" textKey="SkipToFooter_Button" />
    </div>
  );
}

function SkipToButton({ skipTo, textKey, scrollTop = false, ...args }) {
  return (
    <div>
      <button
        type="button"
        data-testid={formatAsTestId(`skip to ${skipTo}`, 'button')}
        onClick={() => moveFocusTo(`#${skipTo}`, scrollTop ? 'top' : undefined)}
        {...args}
      >
        {t(textKey)}
      </button>
    </div>
  );
}

export default translate(SkipToContent);
